import { EmployerFormsPageV2, InitiateGroupPage, InitiateProposalPage, ZywaveGroupInfoPage } from 'pages';
import QuoteAddEmployeesPage from 'pages/quote/add-employees/QuoteAddEmployees';
import QuoteAddEmployeesCensusUploadPage from 'pages/quote/add-employees/CensusUploadPage';
import QuoteAddEmployeesCensusReviewPage from 'pages/quote/add-employees/CensusReviewPage';
import QuoteAddEmployeesFullFormPage from 'pages/quote/add-employees/FullFormPage';
import BrowsingPage from 'pages/BrowsingPage';
import QuoteChecklistPage from 'pages/quote/QuoteChecklistPage';
import QuoteProposalInfoPage from 'pages/quote/quote-proposal-info';
import GroupHubPage from 'pages/GroupHubPage';
import EnrollmentChecklistPage from 'pages/enrollment/ChecklistPage';
import ZywaveQuoteRedirectPage from 'pages/zywave/ZywaveQuoteRedirectPage';
import AddQuotePage from 'pages/quote/AddQuotePage';
import { EnrollmentRouteV2Id, GeneralRouteV2Id, QuoteRouteV2Id, RouteV2Id, ZywaveRouteV2Id } from './routesConfigV2';

const GENERAL_COMPONENTS: Record<GeneralRouteV2Id, React.ComponentType> = {
  [GeneralRouteV2Id.INITIATE_GROUP]: InitiateGroupPage,
  [GeneralRouteV2Id.INITIATE_PROPOSAL]: InitiateProposalPage,
  [GeneralRouteV2Id.GROUP_HUB]: GroupHubPage,
};

const ZYWAVE_COMPONENTS: Record<ZywaveRouteV2Id, React.ComponentType> = {
  [ZywaveRouteV2Id.ZYWAVE_GROUP_INFO]: ZywaveGroupInfoPage,
};

const QUOTE_COMPONENTS: Record<QuoteRouteV2Id, React.ComponentType> = {
  [QuoteRouteV2Id.QUOTE_CHECKLIST]: QuoteChecklistPage,
  [QuoteRouteV2Id.QUOTE_PROPOSAL_INFO]: QuoteProposalInfoPage,
  [QuoteRouteV2Id.QUOTE_ADD_EMPLOYEES_CENSUS_UPLOAD]: QuoteAddEmployeesCensusUploadPage,
  [QuoteRouteV2Id.QUOTE_ADD_EMPLOYEES_CENSUS_REVIEW]: QuoteAddEmployeesCensusReviewPage,
  [QuoteRouteV2Id.QUOTE_ADD_EMPLOYEES_FULL_FORM]: QuoteAddEmployeesFullFormPage,
  [QuoteRouteV2Id.QUOTE_ADD_EMPLOYEES]: QuoteAddEmployeesPage,
  [QuoteRouteV2Id.ZYWAVE_QUOTE_REDIRECT]: ZywaveQuoteRedirectPage,
  /**
   * Temporary browsing page used to avoid showing content under the wrong page.
   * Should be replaced in the flow with the Add Quote (INITIATE_SHELF_ADD_QUOTE) page once it is ready and then removed.
   * The BE will return INITIATE_SHELF_ADD_QUOTE instead of INITIATE_SHELF_BROWSING once Add Quote is implemented.
   */
  [QuoteRouteV2Id.INITIATE_SHELF_BROWSING]: BrowsingPage,
  [QuoteRouteV2Id.INITIATE_SHELF_ADD_QUOTE]: AddQuotePage,
};

const ENROLLMENT_COMPONENTS: Record<EnrollmentRouteV2Id, React.ComponentType> = {
  [EnrollmentRouteV2Id.EMPLOYER_FORMS]: EmployerFormsPageV2,
  [EnrollmentRouteV2Id.ENROLLMENT_CHECKLIST]: EnrollmentChecklistPage,
};

/**
 *  This map contains the new V2 routes mapping to their respective components
 *  Please break them down flow-wise: general, rfq, template, etc.
 */
export const ROUTE_COMPONENTS_MAP: Record<RouteV2Id, React.ComponentType> = Object.freeze({
  ...GENERAL_COMPONENTS,
  ...ZYWAVE_COMPONENTS,
  ...QUOTE_COMPONENTS,
  ...ENROLLMENT_COMPONENTS,
});
